"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _localization = require("@lt/localization");

var _currency = require("../../utils/currency");

var PriceLink = /*#__PURE__*/_react["default"].memo(function (_ref) {
  var className = _ref.className,
      text = _ref.text,
      link = _ref.link,
      price = _ref.price;

  var _useTranslation = (0, _localization.useTranslation)(),
      t = _useTranslation.t;

  return /*#__PURE__*/_react["default"].createElement("div", {
    className: className
  }, text, ' ', /*#__PURE__*/_react["default"].createElement(StyledLink, {
    href: link
  }, t('filters.prices.from'), " ", (0, _currency.formatCurrency)(price)));
});

PriceLink.displayName = 'PriceLink';

var StyledLink = _styledComponents["default"].a.withConfig({
  displayName: "PriceLink__StyledLink",
  componentId: "sc-fs7d3s-0"
})(["text-decoration:none;cursor:pointer;color:", ";"], function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.blue;
});

var _default = PriceLink;
exports["default"] = _default;